<!-- Reactivate Invoice Schedule Modal -->
<div class="modal fade" id="reactivateInvoiceScheduleModal" msEscClose
    (escPressed)="onCancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">
                    Reactivate Invoice Schedule
                </h5>
            </div>

            <div class="modal-body">
                @if (scheduleName()) {
                    <p class="mb-3">
                        Set the new Issued Date and Due Date to reactivate
                        <strong>{{ scheduleName() }}</strong>.
                    </p>
                }

                <form [formGroup]="reactivateForm" (keydown.enter)="$event.preventDefault()">

                    <!-- Issued Date -->
                    <ms-input-label
                        [labelText]="'Issued Date'"
                        [isRequired]="isFieldRequired(reactivateForm, 'issuedDate')" />
                    <input
                        type="date"
                        id="reactivateIssuedDate"
                        formControlName="issuedDate"
                        [required]="isFieldRequired(reactivateForm, 'issuedDate')"
                        class="form-control"
                        [class.is-invalid]="reactivateForm.get('issuedDate')?.invalid && reactivateForm.get('issuedDate')?.touched"
                        [class.is-valid]="reactivateForm.get('issuedDate')?.valid && reactivateForm.get('issuedDate')?.touched" />
                    @if (reactivateForm.get('issuedDate')?.invalid && reactivateForm.get('issuedDate')?.touched) {
                        <div class="error-messages">
                            @if (reactivateForm.get('issuedDate')?.errors?.['required']) {
                                <p class="text-danger text-start pt-1 mb-0">A valid issued date is required</p>
                            }
                            @if (reactivateForm.get('issuedDate')?.errors?.['futureDate']) {
                                <p class="text-danger text-start pt-1 mb-0">{{ reactivateForm.get('issuedDate')?.errors?.['futureDate'].message }}</p>
                            }
                        </div>
                    }

                    <!-- Due Date -->
                    <ms-input-label
                        [labelText]="'Due Date'"
                        [isRequired]="isFieldRequired(reactivateForm, 'dueDate')"
                        class="mt-3" />
                    <input
                        type="date"
                        id="reactivateDueDate"
                        formControlName="dueDate"
                        [required]="isFieldRequired(reactivateForm, 'dueDate')"
                        class="form-control"
                        [class.is-invalid]="reactivateForm.get('dueDate')?.invalid && reactivateForm.get('dueDate')?.touched"
                        [class.is-valid]="reactivateForm.get('dueDate')?.valid && reactivateForm.get('dueDate')?.touched" />
                    @if (reactivateForm.get('dueDate')?.invalid && reactivateForm.get('dueDate')?.touched) {
                        <div class="error-messages">
                            @if (reactivateForm.get('dueDate')?.errors?.['required']) {
                                <p class="text-danger text-start pt-1 mb-0">A valid due date is required</p>
                            }
                            @if (reactivateForm.get('dueDate')?.errors?.['futureDate']) {
                                <p class="text-danger text-start pt-1 mb-0">{{ reactivateForm.get('dueDate')?.errors?.['futureDate'].message }}</p>
                            }
                            @if (reactivateForm.get('dueDate')?.errors?.['dueBeforeIssuance']) {
                                <p class="text-danger text-start pt-1 mb-0">{{ reactivateForm.get('dueDate')?.errors?.['dueBeforeIssuance'].message }}</p>
                            }
                        </div>
                    }

                    @if (showEndDateControls()) {
                        <!-- End Date opt-in -->
                        <div class="form-check mt-3">
                            <input
                                type="checkbox"
                                id="reactivateEndDateEnabled"
                                formControlName="endDateEnabled"
                                class="form-check-input" />
                            <label class="form-check-label" for="reactivateEndDateEnabled">
                                Set an End Date
                            </label>
                        </div>

                        @if (reactivateForm.get('endDateEnabled')?.value) {
                            <ms-input-label
                                [labelText]="'End Date'"
                                [isRequired]="false"
                                class="mt-3" />
                            <input
                                type="date"
                                id="reactivateEndDate"
                                formControlName="endDate"
                                class="form-control"
                                [class.is-invalid]="reactivateForm.get('endDate')?.invalid && reactivateForm.get('endDate')?.touched"
                                [class.is-valid]="reactivateForm.get('endDate')?.valid && reactivateForm.get('endDate')?.touched && reactivateForm.get('endDate')?.value !== ''" />
                            @if (reactivateForm.get('endDate')?.invalid && reactivateForm.get('endDate')?.touched) {
                                <div class="error-messages">
                                    @if (reactivateForm.get('endDate')?.errors?.['futureDate']) {
                                        <p class="text-danger text-start pt-1 mb-0">{{ reactivateForm.get('endDate')?.errors?.['futureDate'].message }}</p>
                                    }
                                    @if (reactivateForm.get('endDate')?.errors?.['endBeforeIssuance']) {
                                        <p class="text-danger text-start pt-1 mb-0">{{ reactivateForm.get('endDate')?.errors?.['endBeforeIssuance'].message }}</p>
                                    }
                                    @if (reactivateForm.get('endDate')?.errors?.['endBeforeMonthEnd']) {
                                        <p class="text-danger text-start pt-1 mb-0">{{ reactivateForm.get('endDate')?.errors?.['endBeforeMonthEnd'].message }}</p>
                                    }
                                </div>
                            }
                        }
                    }
                </form>
            </div>

            <div class="modal-footer border-0 d-flex justify-content-center pb-4">
                <button type="button" class="btn btn-ms-secondary" (click)="onCancel()" [disabled]="isSubmitting">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isSubmitting">
                    @if (isSubmitting) {
                        <div class="spinner-border text-light spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    } @else {
                        Reactivate
                    }
                </button>
            </div>

        </div>
    </div>
</div>

<!-- Info Modal -->
<ms-info-modal #reactivateInvoiceScheduleInfoRef modalId="reactivateInvoiceScheduleInfoModal"
    (onConfirm)="infoModalConfirmed()" />

<!-- Esc Confirmation Modal -->
<ms-confirmation-modal
    #reactivateInvoiceScheduleEscConfirmationRef
    modalId="reactivateInvoiceScheduleEscConfirmationModal"
    confirmButtonText="Leave"
    cancelButtonText="Stay"
    (confirmed)="onEscConfirmed()"
    (cancelled)="onEscCancelled()"
/>
